
/*
|------------------------------------------------------------------------------------
| Disable form once the user click on save or submet btn.
|------------------------------------------------------------------------------------
*/
$("form.disabled :input").prop("disabled", true)

$(".print-btn").click(() => {
    window.print()
})

$('form:not(.delete)').submit(function () {
    $('form').find('button:not(.print)').attr('disabled', 'disabled')
    $(this).submit()
})

$('.one-click').click(function (e) {
    e.preventDefault()
    $(this).attr('disabled', 'disabled')
    window.location = $(this).attr('href')
})

$('fieldset[disabled] select').prop('disabled', true);





/*
|------------------------------------------------------------------------------------
| Auto hide alert message
|   fadeTo(speed, opacity)
|------------------------------------------------------------------------------------
*/
$(document).ready(function () {

    window.setTimeout(function () {
        $(".alert").fadeTo(4000, 0).slideUp(1000, function () {
            $(this).remove();
        });
    }, 1000);

});





/*
|------------------------------------------------------------------------------------
| Display image on popover
|------------------------------------------------------------------------------------
*/
$('[data-rel=popover]').popover({
    html: true,
    content: function () { return '<img src="' + $(this).data('img') + '" />'; }
});





/*
/------------------------------------------------------------------------------------
/ COPY TO CLIPBOARD
/ Attempts to use .execCommand('copy') on a created text field
/ Falls back to a selectable alert if not supported
/ Attempts to display status in Bootstrap tooltip
/------------------------------------------------------------------------------------
*/
function copyToClipboard(text, el) {
    var copyTest = document.queryCommandSupported('copy');
    var elOriginalText = el.attr('data-original-title');

    if (copyTest === true) {
        var copyTextArea = document.createElement("textarea");
        copyTextArea.value = text;
        document.body.appendChild(copyTextArea);
        copyTextArea.select();
        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'تم النسخ' : 'تعذر النسخ!';
            el.attr('data-original-title', msg).tooltip('show');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(copyTextArea);
        el.attr('data-original-title', elOriginalText);
    } else {
        // Fallback if browser doesn't support .execCommand('copy')
        window.prompt("Copy to clipboard: Ctrl+C or Command+C, Enter", text);
    }
}

$(document).ready(function () {
    // Initialize Copy to clipboard
    // Grab any text in the attribute 'data-copy' and pass it to the copy function
    $('.js-copy').click(function () {
        var text = $(this).attr('data-copy');
        var el = $(this);
        copyToClipboard(text, el);
    });
});




/*
|------------------------------------------------------------------------------------
| Disable the forms submissions until they have changed
|------------------------------------------------------------------------------------
*/
$(window).on('load', function (e) {
    $('form').each(function () {
        $(this).data('serialized', $(this).serialize())
    })
        .on('change input', function () {
            $(this).find(':submit:not(.delete), input[type="image"]')
                .prop('disabled', $(this).serialize() == $(this).data('serialized'));

            /* Check if input with type files has changed */
            var changedFiles = $(":file").filter(function (index) {
                return this.value != this.defaultValue;
            }).length;

            if (changedFiles > 0) {
                $(this).find(':submit:not(.delete), input[type="image"]')
                    .prop('disabled', false);
            }
        })
        // .find(':submit:not(.delete), input[type="image"]').prop('disabled', true);
});


/*
|------------------------------------------------------------------------------------
| We change select we send the form
|------------------------------------------------------------------------------------
*/
$('select.onchange').change(function() {
    // $(this).parents('form').submit()
    $(this).closest('form')[0].submit();
})
